<bl-page-card-container
  data-smartpresentation="container-pagina"
  id="resumo-guias-rede-propria"
  backNavigation=".."
  [showTooltip]="true"
  [tooltipKey]="pageTooltip"
  (onCopyUrlFilters)="onCopyUrlFilters()"
  >
  <ng-container header>
    <div class="flex align-items-center">
      <ag-views-toolbar
        [grid]="activeTabIndex === 0 ? agGrid : agGridReceita"
        [gridKey]="activeTabIndex === 0 ? GRID_KEY : GRID_KEY_RECEITA"
        class="mr-5"
      ></ag-views-toolbar>

      <!-- HEADER ABA 1 -->
      @if (activeTabIndex === 0) {
        <bl-competencia
          [competencia]="competenciaRange[0]"
          [competenciaFinal]="competenciaRange[1]"
          (apply)="competenciaChanged($event)"
        ></bl-competencia>
        <button
          data-smartpresentation="botao-pesquisar"
          pButton
          type="button"
          icon="pi pi-search"
          iconPos="left"
          label="Pesquisar"
          class="ml-2 p-button p-button-md"
          [ngClass]="{ 'p-disabled': !filterChanged }"
          (click)="reloadData()"
        ></button>
        <button
          class="p-button p-button-outlined p-button-icon-only ml-4"
          (click)="exportExcel()"
          pTooltip="Exportar Listagem como XLSX"
          tooltipPosition="bottom"
          [disabled]="!rowData?.length"
          >
          <i class="pi pi-file-excel"></i>
        </button>
      }

      <!-- HEADER ABA 2 -->
      @if (activeTabIndex === 1) {
        <button
          data-smartpresentation="botao-pesquisar"
          pButton
          type="button"
          icon="pi pi-search"
          iconPos="left"
          label="Pesquisar"
          class="ml-2 p-button p-button-md"
          [ngClass]="{ 'p-disabled': !filterChangedFiliais }"
          (click)="reloadData()"
        ></button>
        <button
          class="p-button p-button-outlined p-button-icon-only ml-4"
          (click)="exportExcelReceita()"
          pTooltip="Exportar Filiais ativas como XLSX"
          tooltipPosition="bottom"
          [disabled]="!rowDataReceita?.length"
          >
          <i class="pi pi-file-excel"></i>
        </button>
        <small class="ml-3">Último processamento em: {{ dtUltimoProcessamentoFiliais || '-' }}</small>
      }

      <button
        data-smartpresentation="botao-tela-cheia"
        class="p-button p-button-outlined p-button-icon-only ml-2"
        (click)="toggleFullscreen()"
        pTooltip="Tela Cheia"
        tooltipPosition="bottom"
        >
        <i
          class="pi"
          [ngClass]="{ 'pi-window-maximize': !(fullscreen$ | async), 'pi-window-minimize': (fullscreen$ | async) }"
          >
        </i>
      </button>
    </div>
  </ng-container>

  <div class="flex flex-1 overflow-hidden">
    <p-tabs class="w-full" [value]="activeTabIndex" (valueChange)="onTabChange($event)">
      <p-tablist>
        <!-- ABA 1 -->
        <p-tab [value]="0">Prestadores com guias</p-tab>
        <!-- ABA 2 -->
        <p-tab [value]="1">Filiais ativas na RFB</p-tab>
      </p-tablist>
      <p-tabpanels>
      <!-- ABA 1 -->
      <p-tabpanel [value]="0">
        <ng-container>
          <ag-grid-angular
            #agGrid
            data-smartpresentation="ag-grid"
            class="ag-theme-balham w-full flex-1"
            [style.height]="gridHeight$ | async"
            [rowData]="rowData"
            [gridOptions]="gridOptions"
            [overlayLoadingTemplate]="firstLoad ? 'Clique em Pesquisar para exibir os registros' : null"
            >
          </ag-grid-angular>
        </ng-container>
      </p-tabpanel>

      <!-- ABA 2 -->
      <p-tabpanel [value]="1">
        @if (activeTabIndex === 1) {
          <ag-grid-angular
            #agGridReceita
            class="ag-theme-balham w-full"
            [style.height]="gridHeight$ | async"
            [rowData]="rowDataReceita"
            [gridOptions]="gridReceitaOptions"
            >
          </ag-grid-angular>
        }
      </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</bl-page-card-container>

<p-dialog
  [(visible)]="dialogDisplay"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="true"
  (onMaximize)="onDialogMaximize($event)"
  (onHide)="onDialogHide($event)"
  [style]="{ width: '90vw', height: '90vh' }"
  >
  <ng-template pTemplate="header">
    <div class="flex justify-content-between w-full">
      <h5>Listagem de guias de rede própria</h5>
      <div class="flex align-items-center gap-2 mr-2">
        <button
          class="p-button p-button-outlined p-button-icon-only mr-2"
          (click)="exportExcelDialog()"
          pTooltip="Exportar Listagem como XLSX"
          tooltipPosition="bottom"
          [disabled]="!dialogData?.length"
          >
          <i class="pi pi-file-excel"></i>
        </button>
        <!-- <button
        pButton
        pRipple
        type="button"
        icon="pi pi-angle-left"
        class="p-button-secondary p-button-text p-button-rounded p-button-icon-only"
        (click)="showDialogForPrev()"
        [disabled]="!canPrev()"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-angle-right"
        class="p-button-secondary p-button-text p-button-rounded p-button-icon-only"
        (click)="showDialogForNext()"
        [disabled]="!canNext()"
      ></button> -->
    </div>
  </div>
</ng-template>

<div class="flex justify-content-end mb-2">
  <div class="flex align-items-center">
    <ag-views-toolbar [grid]="agGridDialog" [gridKey]="GRID_DIALOG_KEY"> </ag-views-toolbar>
  </div>
</div>

<div style="height: calc(90vh - 120px); margin-top: 10px">
  <ag-grid-angular
    #agGridDialog
    class="ag-theme-balham w-full h-full"
    [rowData]="dialogData"
    [gridOptions]="gridDialogOptions"
    >
  </ag-grid-angular>
</div>
</p-dialog>
